import { ReactNode, useState } from 'react';

import cs from 'classnames';
import { motion } from 'framer-motion';

import { ReactComponent as AddIcon } from 'assets/icons/addPlus.svg';
import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';

import styles from './DataAccordionView.module.scss';

interface DataAccordionViewProps {
  title: string;
  placeholder: string;
  children: ReactNode | null;
}

const DataAccordionView = ({
  title,
  placeholder,
  children
}: DataAccordionViewProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  if (!children) {
    return <div className={styles.placeholder}>{placeholder}</div>;
  }

  return (
    <div>
      <div onClick={toggleOpen} className={styles.titleWrapper}>
        <div
          className={cs(styles.iconWrapper, {
            [styles.open]: isOpen
          })}
        >
          {isOpen ? <MinusIcon /> : <AddIcon />}
        </div>

        <span className={cs(styles.title, { [styles.open]: isOpen })}>
          {title}
        </span>
      </div>
      <motion.div layout>{isOpen && children}</motion.div>
    </div>
  );
};

export default DataAccordionView;
